const { toString } = require('../../../../common/frontend/helpers/params');

module.exports = {
  save(params) {
    return fetch(
      `/partial/homepage/update-taxonomy-preference?${toString(params)}`,
      { credentials: 'same-origin' }
    )
      .then(res => {
        if (res.status > 200) {
          return Promise.reject(res);
        } else {
          return Promise.resolve(res);
        }
      })
      .then(res => res.json());
  },
  fetch(params) {
    return fetch(
      `/partial/homepage/get-taxonomy-preference?${toString(params)}`,
      { credentials: 'same-origin' }
    )
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        return Promise.resolve(data);
      })
      .catch(e => {
        return Promise.reject(e);
      });
  },
};
